<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h4 style="color: white;">Nuevo Usuario DANE</h4>
    </div>
    <div class="card-body">
      <form>
        <div class="container">
          <!--div class="row justify-content-md-center">
            <div class="col-1" style="text-align: right;">
              <label>Perfil</label>
            </div>
            <div class="col-2" style="text-align: left;">

            </div>
          </div>
          <br>
          <div><b>Responsable del usuario y clave</b></div>
          <div class="row">
            <div class="col" style="text-align: right;">
              <a>Ingresar usuario DANE</a>
            </div>
            <div class="col">
              <input class="form-control" name="usuariodane" [(ngModel)]="buscarUsuario">
            </div>
            <div class="col">
              <button class="btn btn-primary" (click)="BuscarUsuario(buscarUsuario)">Buscar</button>
            </div>
          </div-->
          <div class="row">
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Perfil:</a>
              </div>
              <div class="row">
                <select class="form-select" name="rol" [formControl]="rol" (change)="BuscarUsuario()">
                  <option value="" selected>Seleccionar</option>
                  <option value="1">Administrador</option>
                  <option value="2">Tematico</option>
                  <option value="3">Operativo</option>
                </select>
              </div>
            </div>
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Usuario:</a>
              </div>
              <div class="row">
                <input class="form-control" name="username" [formControl]="usuario" disabled>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Tipo documento:</a>
              </div>
              <div class="row">
                <select class="form-select" name="tipoidentifiacion" [formControl]="tipodocumento" (change)="Update()">
                  <option value="" selected></option>
                  <option value="CC">Cédula de ciudadanía</option>
                  <option value="CE">Cédula de extranjería</option>
                </select>
              </div>
            </div>
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Número documento:</a>
              </div>
              <div class="row">
                <input class="form-control" name="numdocumento" maxlength="10" [formControl]="numerodocumento" (change)="Update()" oninput="this.value = this.value.replace(/[^0-9]/g, '')">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Nombres:</a>
              </div>
              <div class="row">
                <input class="form-control" name="nombres" [formControl]="nombres" (change)="Update()" oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')">
              </div>
            </div>
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Apellidos:</a>
              </div>
              <div class="row">
                <input class="form-control" name="apellidos" [formControl]="apellidos" (change)="Update()" oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Correo:</a>
              </div>
              <div class="row">
                <input class="form-control" name="correo1" [formControl]="correousuario" (change)="Update()">
              </div>
            </div>
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Confirmar correo:</a>
              </div>
              <div class="row">
                <input class="form-control" name="correo2" [formControl]="correousuario1" (change)="VerificarCorreo()">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Télefono:</a>
              </div>
              <div class="row">
                <input class="form-control" name="telefono" maxlength="10" [formControl]="telefonousuario" (change)="Update()" oninput="this.value = this.value.replace(/[^0-9]/g, '')">
              </div>
            </div>
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Extensión:</a>
              </div>
              <div class="row">
                <input class="form-control" name="extencion" maxlength="5" [formControl]="extencionusuario" (change)="Update()" oninput="this.value = this.value.replace(/[^0-9]/g, '')">
              </div>
            </div>
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Cargo:</a>
              </div>
              <div class="row">
                <input class="form-control" name="cargo" maxlength="20" [formControl]="cargousuario" (change)="Update()" oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')">
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer">
      <button type="button" class="btn btn-secondary" (click)="regresar()">Cancelar</button>
      <button type="button" class="btn btn-primary" (click)="GuardarNuevoUsuario()" [disabled]="btnguardar"
      *ngIf="!BTNguardar()">Guardar</button>
      <button type="button" class="btn btn-secondary" (click)="VerificarCampos()"
      *ngIf="BTNguardar()">Guardar</button>
    </div>
  </div>
</body>

<!--Modal Cargando-->
<button class="btn btn-primary btn-sm" #openmodalcargando data-toggle="modal"  data-target="#modal-cargando" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-md" id="modal-cargando" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-body">
        <div class="card-body container-fluid">
          <br>
          <div class="row">
            <div class="col-auto" style="margin: auto;">
              <h5>Cargando y verificando información, espere un momento...</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closemodacargando style="visibility: hidden;">
                <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
              </button>
            </div>
            <div class="d-flex justify-content-center">
              <div class="spinner-border text-danger" role="status" style="width: 60px; height: 60px;">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <br>
        </div>
      </div>
    </div>
  </div>
</div>
